import React from 'react'
import { withRouter } from 'react-router'
import MessageUI from '../../../widgets/output/MessageUI'
import SearchUI from '../../../widgets/input/SearchUI'
import AvatarUI from '../../../widgets/output/AvatarUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../../widgets/action/IconButtonLinkUI'
import './ProjectUserList.css'

const ProjectUserListUI = ({context, messageList, project, projectUserList,
    // filters
    memberFilter, nonMemberFilter, searchFilter,
    onMemberFilterClick, onNonMemberFilterClick, onSearchFilterChange,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onUpdateClick, onDeleteClick, onRowClick}) =>
  <div className='c_prj_users'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick }
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          project={project}
          messageList={messageList}
          memberFilter={memberFilter}
          nonMemberFilter={nonMemberFilter}
          searchFilter={searchFilter}
          onMemberFilterClick={onMemberFilterClick}
          onNonMemberFilterClick={onNonMemberFilterClick}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI>
      {
        projectUserList.map((projectUser, i) =>
          <ProjectUserRowUI key={i} context={context} project={project} projectUser={projectUser}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, selectedCount, onRefreshClick, onUpdateClick, onDeleteClick}) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        {
          context.permissions.includes('acc_manage') &&
          <IconButtonLinkUI messageList={messageList} icon='icon-user-plus' to='/settings/members/invite' labelKey='c_invite_user' />
        }
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_users' />
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_remove_users' />
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({context, messageList, project, memberFilter, nonMemberFilter, searchFilter,
    onMemberFilterClick, onNonMemberFilterClick, onSearchFilterChange
  }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    {
      (context.permissions.includes('acc_manage') || project.permissionList.includes('prj_manage')) &&
      <React.Fragment>
        <div className='g_m_left_25'>
          <input type="checkbox" checked={memberFilter} onChange={onMemberFilterClick} />
          <MessageUI messageList={messageList} messageKey='c_members' />
        </div>
        <div className='g_m_left_25'>
          <input type="checkbox" checked={nonMemberFilter} onChange={onNonMemberFilterClick} />
          <MessageUI messageList={messageList} messageKey='c_non_members' />
        </div>
      </React.Fragment>
    }
  </div>

const ProjectUserRowUI = ({context, messageList, project, projectUser, onRowClick}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} project={project} projectUser={projectUser} onRowClick={onRowClick} />}
    right={<RowRightUI projectUser={projectUser} messageList={messageList} />}
    onClick={(context.permissions.includes('acc_manage') || project.permissionList.includes('prj_manage')) ? onRowClick : null}
    rowId={projectUser.userId}
  />

const RowLeftUI = ({context, project, projectUser, onRowClick}) =>
  <React.Fragment>
    {/* if React.Fragment is replaced with html element
      must add flex to the html element */}
    {
      (context.permissions.includes('acc_manage') || project.permissionList.includes('prj_manage')) &&
      <input type="checkbox" className='checkbox' checked={projectUser.selected} onChange={() => {}}
      />
    }
    <AvatarUI avatarUrl={projectUser.avatarUrl} />
    <label className='name'>
      {projectUser.name}
    </label>
    {
      projectUser.userId === context.session.userId &&
      <div className='self'></div>
    }
  </React.Fragment>

const RowRightUI = ({projectUser, messageList}) =>
  <div className='g_flex_h'>
    <span className='g_muted'>
      {projectUser.roleName}
    </span>
  </div>

export default withRouter(ProjectUserListUI)
